import * as React from 'react';
import { LoadingIndicator, LocalesMenuButton, Logout, UserMenu } from 'react-admin';

export const AppBarToolbar = () => (
  <>
    <LocalesMenuButton languages={[{ locale: 'en', name: 'English' }]} />
    <LoadingIndicator />
    <UserMenu>
      <Logout />
    </UserMenu>
  </>
);
